import { combineReducers } from "redux"
import mainDashboard from "./mainDashboard"
// import mainDashboard2 from "./mainDashboard2"

const dashboardReducer = combineReducers({
    main: mainDashboard
})

export default dashboardReducer